import React from "react";

import { Typography, ButtonBase, Theme } from "@mui/material";
import clsx from "clsx";
import { isToday, format } from "date-fns";
import { NavLink } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles<void, "root">()(
  (theme: Theme, _params, classes) => ({
    root: {
      [`& ~ .${classes.root}`]: {
        marginLeft: theme.spacing(2),
      },
    },
    boxlink: {
      textDecoration: "none",
      width: "112px",
      height: "96px",
      color: theme.palette.common.black,
      backgroundColor: colors.white,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    active: {
      textDecoration: "none",
      background: "linear-gradient(0deg, #FF972C 0%, #FFBA1B 100%)",
      borderRadius: "5px",
      color: theme.palette.common.white,
    },
    today: {
      border: "2px solid rgba(255, 157, 55, 0.5)",
      borderRadius: "5px",
    },
  })
);

type BoxLinkProps = React.ComponentProps<typeof NavLink> & {
  date: Date;
};

const BoxLink: React.FC<BoxLinkProps> = (props) => {
  const { classes } = useStyles();
  const today = Boolean(isToday(props.date));
  const dayOfTheWeek = format(props.date, "cccc");
  const dateOfTheDay = format(props.date, "dd");
  return (
    <ButtonBase className={classes.root}>
      <NavLink
        {...props}
        className={({ isActive }) =>
          clsx(
            classes.boxlink,
            today && classes.today,
            isActive && classes.active
          )
        }
      >
        <Typography variant="h6">{dateOfTheDay}</Typography>
        <Typography variant="body2">
          {today ? "Today" : dayOfTheWeek}
        </Typography>
      </NavLink>
    </ButtonBase>
  );
};

export default BoxLink;
